export default __webpack_public_path__ + "static/media/covmo.945d135b.png";